import script from "./LCDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./LCDetailView.vue?vue&type=script&setup=true&lang=js"

import "./LCDetailView.vue?vue&type=style&index=0&id=9b2fc830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b2fc830"]])

export default __exports__